<script>
  import options from './DeleteCommentOverlay.options'
  export default options
</script>

<template>
  <article class="kb-delete-comment-overlay">
    <section class="kb-delete-comment-overlay__hero">
      <div class="kb-delete-comment-overlay__hero__title-wrapper">
        <h2 class="kb-delete-comment-overlay__hero__title-wrapper__title">
          {{ getLabel('title') }}
        </h2>
      </div>

      <div class="kb-delete-comment-overlay__breaker">
        <svg viewBox="0 0 81 11" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z" /></svg>
      </div>
      
      <div class="kb-delete-comment-overlay__description">
        <p class="kb-delete-comment-overlay__description-text">{{ getLabel('text') }}</p>
      </div>
    </section>

    <div class="kb-delete-comment-overlay__hero__curve">
      <svg viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
      </svg>
    </div>

    <div class="kb-delete-comment-overlay__body">
        <button class="kb-button kb-button--full-color-spot" v-on:click="deleteComment">{{ getLabel('deleteButton') }}</button>
    </div>
  </article>
</template>
